import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {ApiService} from "../../../services/api.service";
import {Ad, AdType, PriceType} from "../../../interfaces/ad";
import {Location} from "@angular/common";
import {CipherType} from "../../../interfaces/cipher";
import { DefaultFrameComponent } from '../../../frames/default-frame/default-frame.component';
import { KazInputComponent } from '../../../components/kaz-input/kaz-input.component';
import { FormsModule } from '@angular/forms';
import { KazButtonComponent } from '../../../components/kaz-button/kaz-button.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'kaz-edit-ad',
    templateUrl: './edit-ad.component.html',
    styleUrls: ['./edit-ad.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DefaultFrameComponent, KazInputComponent, FormsModule, KazButtonComponent, FaIconComponent]
})
export class EditAdComponent implements OnInit {
  private _route = inject(ActivatedRoute);
  private _router = inject(Router);
  private _api = inject(ApiService);
  private _location = inject(Location);

  ad: Ad | null = null;
  updatedAd: Partial<Ad> | null = null;
  price: string = "";

  ngOnInit() {
    this._route.params.subscribe(params => {
      const adId = params['id']!;
      this.getAd(adId).then();
    });
  }

  async getAd(id: string) {
    try {
      if (id !== '') {
        this.ad = await this._api.getAd(id);
        this.price = String(this.ad.price);
      }
    } catch (err) {

    }
  }

  async updateAd() {
    try {
      if (this.ad !== null) {
        this.updatedAd = {
          id: this.ad.id,
          category: this.ad.category,
          adType: this.ad.adType,
          title: this.ad.title,
          description: this.ad.description,
          priceType: this.ad.priceType,
          price: +this.price,
        };
        const data = await this._api.updateAd(this.updatedAd);
        this._router.navigate(['profile']).then();
      }
    } catch (err) {
      console.log(err);
    }
  }

  onAdTypeChange(typ: AdType.OFFER | AdType.WANTED | AdType.GOOD_DEED) {
    if (this.ad !== null) {
      this.ad.adType = typ;
      this.ad.price = 0;
      this.ad.publicationDate = [];
      this.ad.cipher.type = CipherType.NONE;
      this.ad.category.subName = '';
    }
  }

  onAdPriceTypeChange(typ: PriceType) {
    if (this.ad !== null) {
      this.ad.priceType = typ;
    }
  }

  isFormIncomplete(): boolean {
    if (this.ad !== null)
      return (
        this.ad.title === "" ||
        this.ad.description === ""
      );
    else
      return true;
  }

  formatInput(event: any) {
    // Entfernen alle Nicht-Ziffern aus Eingabe
    const input = event.target.value.replace(/[^0-9]/g, '');
    if (input == '')
      this.price = "0";
  }

  allowOnlyNumbers(event: KeyboardEvent) {
    if (event.key === 'Backspace') {
      return;
    }

    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }

  checkPrice(event: any) {
    if (event.target.value === "0")
      this.price = "";
  }

  goBack() {
    this._location.back();
  }

  protected readonly PriceType = PriceType;
  protected readonly AdType = AdType;
}
